import INS from './default_instance'

// 查询一些数据
export const querySome = (params) => INS.get('/manager/api/commondata/exam_area_list_by_user', { params })
// 获取个性化订单科室与项目
export const getPersonalizedItems = (params) => INS.get('/manager/machineapi/union/get_exam_dept_format_list', { params })
// 获取套餐信息
export const getPackage = (params) => INS.get('/manager/machineapi/package/get_package_list', { params })
// 项目互斥检测
export const checkMutex = (params) => INS.get('/manager/machineapi/machine/compare_union_item_same', { params })
// 提交临时订单
export const submitOrder = (data) => INS.post('/manager/machineapi/machine/submit_order', data)
// 获取支付链接
export const payment = (params) => INS.get('/manager/machineapi/payment/get_pay_channel', { params })
// 自助缴费订单搜索
export const orderSearch = (params) => INS.get('/manager/machineapi/payment/unpaid', { params })
// 获取订单支付状态
export const getPaymentResult = (params) => INS.get('/manager/machineapi/payment/result', { params })
// 登记订单
export const orderRegister = (data) => INS.post('/manager/machineapi/Ordermachine/order_register', data)
// 上传头像
export const postAvatar = (data) => INS.post('/manager/machineapi/Ordermachine/upload_cust_photo', data)
// 获取打印套餐列表
export const getPrintList = (params) => INS.get('/manager/machineapi/Ordermachine/get_user_order', { params })
// 获取打印导引单
export const getGuidePdf = (params) => INS.get('/manager/machineapi/Ordermachine/down_guide_pdf', { params })
// 获取条码
export const getBarcode = (params) => INS.get('/manager/machineapi/Ordermachine/order_barcode?', { params })
// 获取排队信息
export const getQueue = (params) => INS.get('/manager/machineapi/queue/get_by_order_code', { params })
// 切换排队
export const switchQueue = (params) => INS.get('/manager/machineapi/queue/switch_queue', { params })
// 获取配置
export const getConfig = (params) => INS.get('/manager/machineapi/setting/get_config', { params })
